<!-- 由 suu 创建于 2021-08-18 星期三 -->
<template>
  <div class="DetailCourse" v-if="curDaydate">
    <template v-if="!$betterwe.isApp() && $http.getEnv() != 'Dev'">
      <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
      <img
        class="dc-over"
        src="https://cdnvue.gymcity.com.cn/uploads/25coach-couese-over-bg?v=1"
        alt=""
      />
    </template>
    <template v-else>
      <!-- 日期列表 -->
      <WeDateTab
        :dayInfo="dayinfo"
        :activedDate="currDay"
        tfrom="detail"
        @dateChange="onDateChange"
      ></WeDateTab>
      <!-- 课程列表 -->
      <div class="dc-list">
        <!-- 当日已约满 -->
        <template v-if="isFull">
          <img
            class="l-full-img"
            src="https://cdnvue.gymcity.com.cn/uploads/pub-yk-full?v=1"
            alt=""
          />
          <div class="l-full-text">人气爆棚！Ta的课已被约满啦</div>
        </template>
        <template v-else-if="course.length <= 0">
          <img
            class="l-full-img"
            src="https://cdnvue.gymcity.com.cn/uploads/pub-yk-null?v=1"
            alt=""
          />
          <div class="l-full-text">当日暂无排课</div>
        </template>
        <template v-else>
          <div
            class="l-item"
            :class="{ 'l-item-off': item.coursenums <= item.left_course }"
            v-for="(item, index) in course"
            :key="index"
          >
            <div class="i-left">
              {{ item.coursestarttime.slice(-8, -3) }} -
              {{ item.courseendtime.slice(-8, -3) }}
            </div>
            <div class="i-right user-btn" @click="onAppoint(item)">
              {{ item.coursenums <= item.left_course ? '约满' : '预约' }}
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import WeDateTab from '@/components/WeDateTab.vue'
export default {
  name: 'DetailCourse',

  components: { WxOpenLaunchApp, WeDateTab },

  props: {
    detailData: {}, // 教练信息 排课信息
    currDay: {} // 当天日期
  },

  data() {
    return {
      extinfo: '',
      curDaydate: null
    }
  },

  computed: {
    // 当天课程列表
    course() {
      // 去掉当前时间之前的课程
      const daydataTemp = Object.keys(this.curDaydate)
        .sort()
        .filter((f) => {
          return (
            new Date(
              this.curDaydate[f].coursestarttime.replace(/-/g, '/')
            ).getTime() > Date.now()
          )
        })
      let arr = []
      daydataTemp.map((v) => {
        arr.push(this.curDaydate[v])
      })
      return arr
    },
    isFull() {
      // 判断是否满课
      let daydataTempCount = 0
      this.course.map((v) => {
        let { coursenums, left_course } = v
        if (coursenums == left_course) {
          daydataTempCount += 1
        }
      })
      if (daydataTempCount == this.course.length && this.course.length !== 0) {
        return true
      }
      return false
    },
    // 导航日期
    dayinfo() {
      return this.$store.state.subscribe.dayinfo // 全局user/home接口获取
    }
  },

  watch: {},

  created() {
    let url =
      location.origin + `/trans-coach-course?coachid=${this.detailData.coachid}`
    this.extinfo = '/web?isJM=1&isAddToken=false&url=' + encodeURIComponent(url)
    // 传入coursetime 表示到详情页请求此日期 排课信息
    if (this.detailData['coursetime']) {
      this.onDateChange(this.detailData['coursetime'])
    } else {
      // 上一步保存的当天排课信息
      this.curDaydate = this.detailData['day_data']
    }
    // this.$http.homeinfo('', '', this.$store.state.curCity.region_id)
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 约课确认弹窗
     */
    onAppoint(obj, e) {
      this.$emit('appointment', obj)
    },
    /**
     * 日期切换
     */
    onDateChange(obj) {
      console.log('====================================')
      console.log('当前日期', obj)
      console.log('====================================')
      this.$toast.loading('加载中...')
      this.$http
        .get2('index/coachClassByDay', {
          cid: this.detailData.coachid,
          day: obj.a_day
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.curDaydate = res.data.data
          }
          this.$toast.clear()
        })
        .catch((err) => {
          // this.$dialog.alert({ message: '数据错误请刷新重进' })
          this.$toast.clear()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.DetailCourse {
  width: 100%;
  box-sizing: border-box;
  .dc-over {
    width: 100%;
    box-sizing: border-box;
  }
  .dc-list {
    width: 100%;
    box-sizing: border-box;
    padding: 0 vw(10);
    .l-full-img {
      width: vw(40);
      margin: 0 auto;
    }
    .l-full-text {
      font-size: 3.7vw;
      color: rgba(0, 0, 0, 0.4);
      text-align: center;
      margin-top: 2.5vw;
    }
    .l-item {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: vw(52);
      background: #f9f9f9;
      border-radius: vw(4);
      padding-left: vw(20);
      padding-right: vw(10);
      .i-left {
        font-size: vw(15);
        font-weight: 500;
        color: #000000;
        font-family: DIN;
      }
      .i-right {
        width: vw(64);
        height: vw(28);
        box-sizing: border-box;
        background: #ff2270;
        box-shadow: vw(0) vw(1) vw(1) vw(0) rgba(0, 0, 0, 0.1);
        border-radius: vw(4);
        font-weight: 600;
        font-size: vw(14);
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .l-item + .l-item {
      margin-top: vw(4);
    }
    .l-item-off {
      .i-left {
        color: rgba(0, 0, 0, 0.3);
      }
      .i-right {
        font-weight: 400;
        background-color: #f9f9f9;
        color: rgba(0, 0, 0, 0.3);
        box-shadow: none;
      }
    }
  }
}
</style>
